const en_facility_category = {
    "": "Facility Categories",
    add: "Add Facility Category",
    edit: "Edit Facility Category",

    label: {
        name: "Facility Category Name"
    },

    error: {
        create: "Failed to create category",
        delete: "Failed to delete category",
        edit: "Failed to edit category",
        name: "Category name is required."
    },

    success: {
        create: "Category created successfully",
        delete: "Category deleted successfully",
        edit: "Category updated successfully",
    },
}

export default en_facility_category;